import { render, staticRenderFns } from "./XImage.vue?vue&type=template&id=bf5997c4&scoped=true&"
import script from "./XImage.vue?vue&type=script&lang=js&"
export * from "./XImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5997c4",
  null
  
)

export default component.exports